import { render } from "./CoffeeTupTevenTineTfive.vue?vue&type=template&id=a6fa4e70"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CoffeeTupTevenTineTfive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6fa4e70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6fa4e70', __exports__)) {
    api.reload('a6fa4e70', __exports__)
  }
  
  module.hot.accept("./CoffeeTupTevenTineTfive.vue?vue&type=template&id=a6fa4e70", () => {
    api.rerender('a6fa4e70', render)
  })

}


export default __exports__